module.exports = __webpack_public_path__ + "img/cards.80355992.png";